export default "__VITE_ASSET__6c21d538__"